import { useTranslation } from 'next-i18next'
import { Stack } from 'components/Stack'
import { Caption, Title, Title_h4_default } from 'components/Typography'
import React, { FC } from 'react'
import { Spacer } from 'components/spacer/Spacer'
import { Block } from 'components/Block'
import { BREAKPOINTS } from 'utils/styled'
import { ArticleCards } from 'components/articlesSection/cards/ArticleCards'
import { ArticleFragment } from 'api/contentful/contentful.graphql.types'
import { PrimaryLink } from 'components/Link'
import styled from '@emotion/styled'
import { formatTextWithLineBreaks } from 'utils/text/formatTextWithLineBreaks'

type BusinessActionCardsProps = {
  articles: ArticleFragment[]
  title?: string
}

const SArticleCardButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const BusinessArticleCards: FC<BusinessActionCardsProps> = (props) => {
  const { t } = useTranslation('business')

  if (props.articles.length === 0) {
    return null
  }

  return (
    <div>
      <Stack css={{ alignItems: 'center' }}>
        <Caption>{t('business.resources_section.subtitle')}</Caption>
        <Spacer size={[1, 1.5]} />
        {props.title && (
          <Title variant={Title_h4_default} css={{ maxWidth: '35rem', textAlign: 'center' }}>
            {formatTextWithLineBreaks(props.title)}
          </Title>
        )}
      </Stack>
      <Spacer size={[1, 1.5, 6]} />
      <Block>
        <div
          css={[
            { display: 'grid', gap: '3rem', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))' },
            BREAKPOINTS.MD.css({
              gridTemplateColumns: 'auto',
              gap: '1rem',
            }),
          ]}
        >
          <ArticleCards articles={props.articles} elegant />
        </div>
      </Block>
      <Spacer size={2} />
      <SArticleCardButton>
        <PrimaryLink href="/articles">{t('business.resources_section.cta')}</PrimaryLink>
      </SArticleCardButton>
      <Spacer size={2} />
    </div>
  )
}
